import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import getPath from 'lodash/get';
import styled from 'styled-components';
import Colors from '../../styles/colors';

class InCart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      enterPromoCode: false,
      promoApplied: false,
      promoCode: props.promoCode,
    };

    this.handlePromoCode = this.handlePromoCode.bind(this);
    this.applyPromoCode = this.applyPromoCode.bind(this);
  }

  componentDidMount() {
    const { promoCode = '' } = this.props;
    this.instantApplyCode(promoCode);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.promoCode !== this.props.promoCode && !this.state.enterPromoCode) {
      this.instantApplyCode(nextProps.promoCode);
    }
  }

  instantApplyCode(promoCode) {
    if (!isEmpty(promoCode)) {
      this.setState({
        promoCode,
      }, this.applyPromoCode);
    }
  }

  handlePromoCode(e) {
    this.setState({
      promoCode: e.target.value,
      promoCodeError: '',
    });
  }

  applyPromoCode() {
    this.setState({
      promoCodeInfo: '',
      promoCodeError: '',
    }, async () => {
      try {
        const { promoCode } = this.state;
        const { promoCodeInfo } = await this.props.onAppliedPromo(promoCode);
        this.setState({
          promoCodeInfo,
          promoApplied: true,
        });
      } catch(err) {
        this.setState({
          promoApplied: false,
          promoCodeError: err.message,
        });
      }
    });
  }

  renderPromoInput() {
    const {
      enterPromoCode,
      promoCode,
      promoApplied,
      promoCodeInfo,
    } = this.state;

    if (promoApplied) {
      return (
        <div className="coupon-info text-large">{promoCodeInfo}</div>
      );
    }

    if (!enterPromoCode) {
      return (
        <button
          className="coupon-btn text-small font-weight-600"
          onClick={() => {
            this.setState({
              enterPromoCode: true,
            }, () => {
              this.refs.promoCodeInput.focus();
            });
          }}
        >
          Have a promo code?
        </button>
      );
    }

    return (
      <div>
        {!promoApplied && (
          <React.Fragment>
            <div style={{ display: 'flex' }}>
              <input
                onChange={this.handlePromoCode}
                className="coupon-input border-radius-4"
                size="20"
                type="text"
                name="promo"
                ref="promoCodeInput"
                placeholder="Enter promo code"
                value={promoCode || ''}
              />
              <button
                type="button"
                className="btn"
                onClick={this.applyPromoCode}
              >
                Apply
              </button>
            </div>
          </React.Fragment>
        )}
      </div>
    );
  }

  renderPromoErrors() {
    const { promoCodeError = '' } = this.state;
    if (isEmpty(promoCodeError)) {
      return null;
    }

    return <div className="coupon-error">{promoCodeError}</div>;
  }

  renderPriceTally() {
    const { priceTally = {} } = this.props;
    const { discounted, discountApplied = 0, coupon = {} } = priceTally;
    const couponCredit = getPath(coupon, 'stripeCredit', 0);
    const rows = [
      {
        title: 'Discount applied',
        value: `-$${discountApplied}`,
        show: discountApplied > 0,
      },
      {
        title: 'Total',
        value: `$${discounted}`,
        show: discountApplied > 0,
      },
      {
        title: 'One off credit',
        value: `-$${couponCredit}`,
        show: couponCredit > 0,
      },
    ];

    return rows.map((row, i) => {
      if (!row.show) return null;
      return (
        <div className="pricing-row" key={`price-tally-${i}`}>
          <div className="text-medium">{row.title}</div>
          <div className="text-large font-weight-700">{row.value}</div>
        </div>
      );
    });
  }

  render() {
    const { title, frequency, price, totalPrice } = this.props;

    return (
      <React.Fragment>
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <OrderDetails>
              <div className="plan-info">
                <div className="plan-title font-weight-700">{title}</div>
                <div>
                  {frequency}
                </div>
              </div>
            </OrderDetails>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <PricingDetails>
              <div className="pricing-row">
                <div className="text-medium">Price</div>
                <div className="text-large font-weight-700">
                  {price}
                </div>
              </div>
              <div className="pricing-row">
                <div className="text-medium"></div>
                {this.renderPromoInput()}
              </div>
              <div className="pricing-row">
                {this.renderPromoErrors()}
              </div>
              {this.renderPriceTally()}
            </PricingDetails>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 ">
            <TotalPrice>
              <div className="total-text text-extra-large">Total today</div>
              <div className="total-price-text title-small font-weight-700">${totalPrice}</div>
            </TotalPrice>
          </div>
        </div>

      </React.Fragment>
    );
  }
}

const OrderDetails = styled.div`
  width: 100%;
  justify-content: flex-start;
  align-items: flex-start;
  display: flex;
  padding-bottom: 10px;

  .plan-info {
    display: flex;
    flex-direction: column;

    .plan-title {
      font-size: 1.7rem;
      display: block;
      line-height: 20px;
      margin-bottom: 3px;
      width: 100%;
      color: ${Colors.fontBlack};
    }

    &.align-center {
      align-self: center;
    }
  }
`;

const PricingDetails = styled.div`
  padding: 10px 0;

  .pricing-row {
    display: flex;
    justify-content: space-between;
    padding: 2px 0;

    .coupon-btn {
      color: #f76b1c;
      background: none;
      border: none;
      padding: 0;
    }

    .coupon-input {
      margin: 0px;
      font-size: 1.4rem;
      padding: 0 5px;
      margin-right: 5px;
    }

    .coupon-info {
      color: #f76b1d;
      font-style: italic;
      text-align: right;
    }

    .coupon-error {
      color: #f44336;
      text-align: right;
      width: 100%;
    }
  }
`;

const TotalPrice = styled.div`
  border-top: 1px solid ${Colors.mainGrey};
  text-align: right;
  margin-bottom: 20px;

  .total-text {
    display: inline-block;
    padding-right: 15px;
  }

  .total-price-text {
    display: inline-block;
  }
`;

InCart.propTypes = {
  title: PropTypes.string,
  frequency: PropTypes.string,
  price: PropTypes.string,
  totalPrice: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  promoCode: PropTypes.string,
  onAppliedPromo: PropTypes.func,
  priceTally: PropTypes.object,
};

InCart.defaultProps = {
  title: '',
  frequency: '',
  price: '',
  totalPrice: '',
  promoCode: '',
  onAppliedPromo: () => {},
  priceTally: {},
};

export default InCart;
